<p-blockUI [blocked]="blocked">
    <div id="center">
        <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
    </div>
</p-blockUI>

<p-panel header="{{protocolStepName}}" [toggleable]="true">
    <div class="mt-1 mx-0 grid justify-content-between h-full">
        <div class="div-button my-1 px-1 py-0 col-12 text-sm start-button flex flex-row text-white" [ngClass]="getStartButtonClass()"
            (click)="startButtonClick()" (keydown.enter)="startButtonClick()">
            <div class="font-bold align-content-center py-1 md:text-sm">
                <span class="text-center word-break">{{protocolStepMap.start.name}}</span>
            </div>
            <div class="w-5 flex flex-column justify-content-around" *ngIf="plateProcessStep['startTimeStamp']!=null">
                <span class="text-right text-xs">{{ plateProcessStep['startPUID'] }}</span>
                <span class="text-right text-xs">{{ getLocalDate(plateProcessStep['startTimeStamp']) | date: 'dd.MM.yy HH:mm' }}</span>
            </div>
        </div>
        <ng-container *ngFor="let actionName of protocolStepMap.actionList;let actionIndex = index">
            <div *ngIf="showLargeButton(actionName)" class="div-button my-1 px-1 py-0 col-12 text-sm action-button flex flex-row text-white"
                (click)="actionButtonClick(actionName, actionIndex)" (keydown.enter)="actionButtonClick(actionName, actionIndex)" [ngClass]="getActionButtonClass(actionName)">
                <div class="font-bold align-content-center py-1">
                    <span class="text-center word-break">{{actionName}}</span>
                    <span *ngIf="isActionCompleted(actionName) && isActionWithTimer(actionIndex)"> [{{ calculateRunningTimeForAction(actionName) }}] </span>
                </div>
                <div class="w-5 flex flex-column justify-content-around" *ngIf="isActionCompleted(actionName)">
                    <span class="text-right text-xs">{{ getActionPUID(actionName) }}</span>
                    <span class="text-right text-xs">{{ getLocalDate(getActionTimeStamp(actionName)) | date: 'dd.MM.yy HH:mm' }}</span>
                </div>
            </div>

            <div *ngIf="showStopAction(actionName)" class="div-button my-1 px-1 py-0 col-12 text-sm flex flex-row text-white"
                (click)="actionButtonClick(actionName, actionIndex)" (keydown.enter)="actionButtonClick(actionName, actionIndex)" [ngClass]="getStopActionButtonClass(actionName)">
                <div class="font-bold align-content-center py-1">
                    <ng-container *ngIf="!isActionCompleted(actionName)">
                        <span class="text-center word-break">{{actionName}}</span>
                        <span> [{{ calculateRunningTimeForAction(actionName.substring(5)) }}] </span>
                    </ng-container>
                    <ng-container *ngIf="isActionCompleted(actionName)">
                        <span class="text-center word-break">{{ actionName.substring(5) }}</span>
                        <span> [{{ calculateRunningTimeForAction(actionName) }}] </span>
                    </ng-container>
                </div>
                <div class="w-5 flex flex-column justify-content-around" *ngIf="isActionCompleted(actionName)">
                    <span class="text-right text-xs">{{ getActionPUID(actionName) }}</span>
                    <span class="text-right text-xs">{{ getLocalDate(getActionTimeStamp(actionName)) | date: 'dd.MM.yy HH:mm' }}</span>
                </div>
            </div>

            <div class="flex align-items-center m-1 justify-content-between w-full" *ngIf="protocolStepMap.actionMap[actionName].actionType == 'WORK_FILE_UPLOAD'">
                <span class="btn font-bold w-6 md:w-10 sm:w-10 action-button h-2rem sm:text-sm text-white border-noround">{{actionName}}</span>
                <input #inboundFileUpload pInputText class="form-control border-1 h-2rem w-6 px-3 py-1 md:text-sm" type="file" 
                    placeholder="Upload File" (change)="onInboundFileSelected($event)" multiple="false" [disabled]="!(isProcessStepActive || protocolStepName === 'ANALYSIS')"/>
                <button pButton icon="fa fa-upload" class="flex justify-content-center h-2rem w-1 action-button text-primary md:text-sm"
                    (click)="onInboundFileUpload(protocolStepMap.actionMap[actionName])" [disabled]="!(isProcessStepActive || protocolStepName === 'ANALYSIS')"></button>
            </div>

            <div *ngIf="protocolStepMap.actionMap[actionName].actionType != 'QC' && protocolStepMap.actionMap[actionName].smallButton"
                class="div-button my-1 px-1 py-0 col-5 text-sm action-button flex flex-row justify-content-around text-white word-break"
                (click)="actionButtonClick(actionName, actionIndex)" (keydown.enter)="actionButtonClick(actionName, actionIndex)" [ngClass]="getActionButtonClass(actionName)">
                <div class="font-bold align-content-center py-1">
                    <span class="text-center">{{actionName}}</span>
                </div>
            </div>

            <div *ngIf="protocolStepMap.actionMap[actionName].actionType == 'QC'"
                class="col-12 p-0 flex justify-content-between">
                <div class="div-button my-1 px-1 w-5 text-sm start-button flex flex-row justify-content-around text-white"
                    (click)="qcPassButtonClick(actionName, actionIndex)" (keydown.enter)="qcPassButtonClick(actionName, actionIndex)" [ngClass]="getActionButtonClass(actionName)">
                    <div class="font-bold align-content-center py-1">
                        <span class="text-center word-break">{{actionName}} Pass</span>
                    </div>
                </div>
                <div class="div-button my-1 px-1 w-5 text-sm stop-action-button flex flex-row justify-content-around text-white"
                    (click)="qcFailButtonClick(actionName, actionIndex)" (keydown.enter)="qcFailButtonClick(actionName, actionIndex)" [ngClass]="getQCFailActionButtonClass(actionName)">
                    <div class="font-bold align-content-center py-1">
                        <span class="text-center word-break">{{actionName}} Fail</span>
                    </div>
                </div>
            </div>

            <div *ngIf="protocolStepMap.actionMap[actionName].actionType == 'WASH_AND_STAIN'"
                class="div-button my-1 px-1 py-0 col-12 text-sm action-button flex flex-row text-white"
                (click)="actionButtonClick(actionName, actionIndex)" (keydown.enter)="actionButtonClick(actionName, actionIndex)" [ngClass]="getActionButtonClass(actionName)">
                <div class="font-bold align-content-center py-1">
                    <span class="text-center word-break">{{actionName}}</span>
                </div>
                <div class="w-5 flex flex-column justify-content-around" *ngIf="isActionCompleted(actionName)">
                    <span class="text-right text-xs">{{ getActionPUID(actionName) }}</span>
                    <span class="text-right text-xs">{{ getLocalDate(getActionTimeStamp(actionName)) | date: 'dd.MM.yy HH:mm' }}</span>
                </div>
            </div>
        </ng-container>
        <div class="flex align-items-center m-1 justify-content-between w-full" *ngIf="protocolStepName === 'ALIQUOTATION'">
            <span class="btn font-bold w-6 md:w-10 sm:w-10 action-button h-2rem sm:text-sm text-white border-noround">Lynx File Upload:</span>
            <input #lynxWorkFileUpload pInputText class="form-control border-1 h-2rem w-6 px-3 py-1 md:text-sm" type="file" placeholder="Upload Lynx File" accept=".txt" (change)="onLynxFileSelected($event)"/>
            <button pButton icon="fa fa-upload" class="flex justify-content-center h-2rem w-1 action-button text-primary md:text-sm" [disabled]="plateProcessStep.step === 'ALIQUOTATION' && plateProcessStep.endTimeStamp !== null" (click)="onLynxFileUpload()"></button>
        </div>
        <div class="div-button my-1 px-1 py-0 col-12 text-sm complete-button flex flex-row text-white" [ngClass]="getEndButtonClass()"
            (click)="endButtonClick()" (keydown.enter)="endButtonClick()">
            <div class="font-bold align-content-center py-1 md:text-sm">
                <span class="text-center word-break">{{protocolStepMap.end.name}}</span>
            </div>
            <div class="w-5 flex flex-column justify-content-around" *ngIf="plateProcessStep['endTimeStamp']!=null">
                <span class="text-right text-xs">{{ plateProcessStep['endPUID'] }}</span>
                <span class="text-right text-xs">{{ getLocalDate(plateProcessStep['endTimeStamp']) | date: 'dd.MM.yy HH:mm' }}</span>
            </div>
        </div>
    </div>
</p-panel>
